import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { approveRefund } from '../refundsEndpoints'
import { refundKeys } from '../refundsQueryKeys'
import { fiatTransactionKeys } from '../../../fiatTransactions/api/fiatTransactionsQueryKeys'
import type { ApproveRefundInput } from '../../types/refundsTypes'

export function useApproveRefundMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: ApproveRefundInput) => approveRefund(input),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: refundKeys.lists() })
      qc.invalidateQueries({ queryKey: refundKeys.statusCounts() })
      qc.invalidateQueries({ queryKey: refundKeys.detail(vars.id) })
      qc.invalidateQueries({ queryKey: fiatTransactionKeys.lists() })
    },
  })
}
